import * as types from './actionTypes';  
import offeringApi from '../api/offeringApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import { loadingRes } from './loadingActions';

export function doOffering() {

  return {
    type: types.DO_OFFERING
  };
}

export function doOfferingRes(data) {  
  return {
    type: types.DO_OFFERING_RES, 
    data
  };
}

export function get_offering(datas) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      offeringApi.doOffering(datas).then(data => {
        dispatch(doOfferingRes(data));
        dispatch(doOfferingRes(null));
        dispatch(loadingRes(false));
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

